import CryptoJS from 'crypto-js'

export const md5 = (pwd: string) => {
  return CryptoJS.MD5(pwd).toString()
}
